import type {
  EntitySuggestion,
  ProcessDraftAssignment,
  ProcessStepRecordingDisplay
} from '@bliks-io/contracts';

/**
 * Projects a `ProcessDraftAssignment` into the `ProcessStepRecordingDisplay`
 * shape so it can share the `displayedSteps` array with recorded steps.
 * Only assignee-related fields are populated — the panel content rendered
 * for assignments (`DraftAssignmentPanel` + `EditableAssignmentContent`)
 * reads assignee/name fields only.
 */
export function draftAssignmentToDisplay(
  assignment: ProcessDraftAssignment,
  processId: string,
  entitySuggestions: EntitySuggestion[] = []
): ProcessStepRecordingDisplay {
  return {
    nodeKind: 'step',
    _id: String(assignment.stableStepId),
    process: processId,
    previousStep: null,
    recordedBy: undefined as unknown as ProcessStepRecordingDisplay['recordedBy'],
    assignedTo: assignment.assignedTo,
    assignedToModel: assignment.assignedToModel,
    whoElseDoesThis: (assignment.whoElseDoesThis ??
      []) as unknown as ProcessStepRecordingDisplay['whoElseDoesThis'],
    inputs: assignment.inputs ?? [],
    actionType: 'task',
    helpers: assignment.helpers as unknown as ProcessStepRecordingDisplay['helpers'],
    entitySuggestions,
    // Draft assignments aren't recordings yet — surface them as in_progress
    // so consumers narrowing on `status` don't crash.
    status: 'in_progress',
    generatedName: assignment.generatedName ?? null,
    generatedDescription: assignment.generatedDescription ?? null,
    laneKey: assignment.laneKey,
    createdAt: '',
    updatedAt:
      assignment.updatedAt instanceof Date
        ? assignment.updatedAt.toISOString()
        : String(assignment.updatedAt ?? '')
  };
}
